/* Reveal on view — shared behavior for the Method steps and Benefits back sections.
   Marks each [data-reveal] child reached as it enters the lower part of the
   viewport (data-threshold sets how much must show; default 0.35); reached states persist. Before this script defines the element (or
   without JS), the CSS shows every item in its final state; reduced-motion users
   get the final state straight away. */

if (!window.customElements.get('reveal-on-view')) {
  class RevealOnView extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-reveal]'));

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.items.forEach((item) => item.classList.add('is-reached'));
        return;
      }

      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-reached');
              this.io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: parseFloat(this.dataset.threshold) || 0.35 }
      );

      this.items.forEach((item) => this.io.observe(item));
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  window.customElements.define('reveal-on-view', RevealOnView);
}
